import angular from "angular";
angular
	.module('app')
	.component('notificationReplyForReview', {
		template: require('./notification-reply-for-review.html'),
		controller: ['$http', controller],
		bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
		}
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.notify = $ctrl.resolve.notification;
	};
}